import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=d8ac6e50&scoped=true&"
import script from "./BaseSection.vue?vue&type=script&lang=js&"
export * from "./BaseSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=d8ac6e50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ac6e50",
  null
  
)

export default component.exports